import { Metrics } from './Metrics';
import { Basics, isTouch } from './Basics';
import { ControllerPage } from '../pages/ControllerPage';
import { ControllerWindow } from '../windows/ControllerWindow';
import { GetBy, C } from './Element';
import { Analytics } from './Analytics';
import { Scroll } from '../scroll/Scroll';
import Sidemenu from '../../../layout/Sidemenu';
import CMP from '../../../windows/Cmp';
import EventDispatcher from './EventDispatcher';
import Cookies from '../utils/Cookies';

const Interaction = {
  FIRST_MOVE: "FIRST_MOVE",

  _idTimer: 0,
  _hasUserInteraction: false,
  _userInteractionCallback: [],
  _hasUserInteractionListener: false,
  positions: {
    old: { x: 0, y: 0 },
    mouse: { x: 0, y: 0 },
    click: { x: 0, y: 0 },
    up: { x: 0, y: 0 },
  },
  isDragging: false,
  isDragged: false,
  options: {},

  init: function (options = {}) {
    this.setOptions(options);
    this._click();

    //if (this.options.drag) {
    this._down();
    this._up();
    //}
    if (this.options.drag || this.options.ajax) {
      this._move();
    }

    if(Cookies.get("user_interaction")) this._hasUserInteraction = true;

    this.positions.mouse.x = Metrics.CENTER_X;
    this.positions.mouse.y = Metrics.CENTER_Y;
  },
  

  setOptions(options = {}) {
    this.options = {
      ajax: options.ajax || false,
      drag: options.drag || false,
      dragIntensity: options.dragIntensity || .1,
      dragCheckTime: options.dragCheckTime * 1000 || 100,
      maxDrag: 4 || Metrics.WIDTH,
      pixelsCheck: options.pixelsCheck || 5,
      onMove: options.onMove || function (n) { Scroll.isScrolling = true; Scroll.move(n) },
      onMouseDown: options.onMouseDown || null,
      onMouseUp: options.onMouseUp || null,
      onDragStart: options.onDragStart || null,
      onDragEnd: options.onDragEnd || null
    };
  },

  _doFirstMove() {
    if(this._hasUserInteraction) return;

    Cookies.add("user_interaction", true);

    this._hasUserInteraction = true;
    EventDispatcher.dispatchEvent(Interaction.FIRST_MOVE);
  },

  _doDragMove(__lastMove = false) {
    let axis = Scroll.axis.toLowerCase();

    this.positions.mouse.distance = this.positions.mouse[axis] - this.positions.old[axis];

    this.positions.mouse.speed = Math.min(this.options.maxDrag, Math.max(1, (Math.abs(this.positions.mouse.distance) * this.options.dragIntensity)));

    if (Math.abs(this.positions.mouse[axis] - this.positions.click[axis]) > this.options.pixelsCheck && !__lastMove) {
      this.isDragged = true;
    }

    this.options.onMove(this.positions.mouse.distance * this.positions.mouse.speed);
  },

  _move: function () {
    document.addEventListener(Basics.moveEvent, (e) => {
      if(!this._hasUserInteraction) this._doFirstMove();

      this.positions.mouse = {
        x: isTouch ? e.touches[0].screenX : e.clientX,
        y: isTouch ? e.touches[0].screenY : e.clientY,
      };

      if (this.isDragging) {
        this._doDragMove()
      } else {
        switch (e.target.tagName.toLowerCase()) {
          case "a":
            //NOT ANCHOR

            if (this.options.ajax &&
              e.target.getAttribute("href").slice(0, 1) !== "#" &&
              e.target.getAttribute("href").indexOf("mailto") < 0 &&
              e.target.getAttribute("href").indexOf("tel") < 0 &&
              e.target.getAttribute("target") !== '_blank' &&
              e.target.getAttribute("data-internal") == null) {

              const href = e.target.getAttribute("href");

              if (ControllerPage.isUrlSameHost(href)) {
                e.preventDefault();
                ControllerPage.preloadPage(e.target.getAttribute("href"));
              }
            }

            break;
        }
      }

      if (this.positions.old.y < this.positions.mouse.y) {
        document.body.classList.add('__mouse-down');
        document.body.classList.remove('__mouse-up');
      } else if (this.positions.old.y > this.positions.mouse.y) {
        document.body.classList.remove('__mouse-down');
        document.body.classList.add('__mouse-up');
      }

      if (this.positions.old.x < this.positions.mouse.x) {
        document.body.classList.add('__mouse-right');
        document.body.classList.remove('__mouse-left');
      } else if (this.positions.old.x > this.positions.mouse.x) {
        document.body.classList.remove('__mouse-right');
        document.body.classList.add('__mouse-left');
      }

      this.positions.old = this.positions.mouse;
    });
  },

  _down: function () {
    document.addEventListener(Basics.downEvent, (e) => {
      this.positions.click = {
        x: isTouch ? e.touches[0].screenX : e.clientX,
        y: isTouch ? e.touches[0].screenY : e.clientY,
      };

      if (this.options.drag) {
        this._idTimer = setTimeout(() => {
          this.positions.mouse = this.positions.old = this.positions.click;
          this.isDragging = true;
          if (this.options.onDragStart) this.options.onDragStart();
        }, this.options.dragCheckTime);
      }

      if (this.options.onMouseDown) {
        this.options.onMouseDown();
      }
    });
  },

  _up: function () {
    document.addEventListener(Basics.upEvent, (e) => {
      clearInterval(this._idTimer);

      this.positions.up = {
        x: isTouch ? e.changedTouches[0].screenX : e.clientX,
        y: isTouch ? e.changedTouches[0].screenY : e.clientY,
      };

      if (this.isDragging) {
        this.isDragging = false;
        if (this.options.onDragEnd) this.options.onDragEnd();
        setTimeout(() => { this.isDragged = false; }, 100);
      }

      if (this.options.onMouseUp) {
        this.options.onMouseUp();
      }
    });
  },

  _click: function () {
    document.addEventListener(Basics.clickEvent, (e) => {
      if(!this._hasUserInteraction) this._doFirstMove();

      if (this.isDragged) {
        e.preventDefault();
      } else {
        const linkEl = e.target.closest('a');
        const buttonEl = !linkEl && e.target.closest('button');

        if (linkEl) {
          //GMT
          if (linkEl.getAttribute("data-gtm-event")) {
            Analytics.sendEvent(linkEl.getAttribute("data-gtm-event"));
          }

          //GA
          if (linkEl.getAttribute("data-ga-event")) {
            Analytics.sendEvent(linkEl.getAttribute("data-ga-event"));
          }

          //TEMP VALUE
          if (linkEl.getAttribute("data-temp-value")) {
            Basics.tempValue = linkEl.getAttribute("data-temp-value");
          }

          //SIDEMENU
          if (linkEl.getAttribute("data-toggle-sidemenu") !== null) {
            Sidemenu.toggleState();
          }

          //TOGGLE CMP
          if (linkEl.getAttribute("data-toggle-cmp") !== null) {
            CMP.toggleState();
          }

          //TOGGLE WINDOW
          if (linkEl.getAttribute("data-toggle-window") !== null) {
            ControllerWindow.toggle(linkEl.getAttribute("data-toggle-window"), linkEl);
          }

          //ANCHOR
          if (linkEl.getAttribute("href").slice(0, 1) === "#") {
            e.preventDefault();
            Scroll.gotoAnchor(linkEl.getAttribute("href").substring(1));

            // BACK
          } else if (linkEl.getAttribute("data-back") !== null) {
            e.preventDefault();
            ControllerPage.back(linkEl.getAttribute("data-href") || linkEl.getAttribute("href"));
          } else if (this.options.ajax && linkEl.getAttribute("data-temp-value")) {
            Basics.tempValue = linkEl.getAttribute("data-temp-value");

            e.preventDefault();
            ControllerPage.changePage(linkEl.getAttribute("href"));
          } else if (this.options.ajax &&
            linkEl.getAttribute("target") !== '_blank' &&
            linkEl.getAttribute("href").indexOf("mailto") < 0 &&
            linkEl.getAttribute("href").indexOf("tel") < 0 &&
            linkEl.getAttribute("data-internal") == null) {

            const href = linkEl.getAttribute("href");

            if (ControllerPage.isUrlSameHost(href)) {
              e.preventDefault();
              C.forEach("[aria-current='page']", (item) => {
                item.removeAttribute("aria-current")
              })
              linkEl.setAttribute("aria-current", "page");

              const historyType = linkEl.getAttribute("data-history") || "push";
              ControllerPage.changePage(href, historyType);
            }
          }
        } else if (buttonEl) {
          //GMT
          if (buttonEl.getAttribute("data-gtm-event")) {
            Analytics.sendEvent(buttonEl.getAttribute("data-gtm-event"));
          }

          //GA
          if (buttonEl.getAttribute("data-ga-event")) {
            Analytics.sendEvent(buttonEl.getAttribute("data-ga-event"));
          }

          //TEMP VALUE
          if (buttonEl.getAttribute("data-temp-value")) {
            Basics.tempValue = buttonEl.getAttribute("data-temp-value");
          }

          //SIDEMENU
          if (buttonEl.getAttribute("data-toggle-sidemenu") !== null) {
            Sidemenu.toggleState();
          }

          //TOGGLE CMP
          if (buttonEl.getAttribute("data-toggle-cmp") !== null) {
            CMP.toggleState();
          }

          //WINDOWS
          if (buttonEl.getAttribute("data-toggle-window") !== null) {
            ControllerWindow.toggle(buttonEl.getAttribute("data-toggle-window"), buttonEl);
          }

          //BACK
          if (buttonEl.getAttribute("data-back") !== null) {
            ControllerPage.back(buttonEl.getAttribute("data-href"));
          }
        }
      }
    });
  }
};

class MrInteraction {
  _idTimer = 0;
  container;
  positions = {
    old: { x: 0, y: 0 },
    mouse: { x: 0, y: 0 },
    click: { x: 0, y: 0 },
    up: { x: 0, y: 0 },
  };
  isDragging = false;
  isDragged = false;
  options = {};

  constructor(__container, __options) {
    this.container = __container;
    this.setOptions(__options);
    //this._click();

    if (this.options.drag) {
      this._down();
      this._up();
    }
    if (this.options.drag || this.options.ajax) {
      this._move();
    }
  }

  setOptions(options = {}) {
    this.options = {
      drag: options.drag || false,
      dragIntensity: options.dragIntensity || .1,
      dragCheckTime: options.dragCheckTime * 1000 || 100,
      maxDrag: 4 || Metrics.WIDTH,
      pixelsCheck: options.pixelsCheck || 5,
      onMove: options.onMove || null,
      onMouseDown: options.onMouseDown || null,
      onMouseUp: options.onMouseUp || null,
      onDragStart: options.onDragStart || null,
      onDragEnd: options.onDragEnd || null,
      axis: options.axis || "X"
    };
  }

  dispose() { }

  _doDragMove(__lastMove = false) {
    let axis = this.options.axis;
    this.positions.mouse.distance = this.positions.mouse[axis] - this.positions.old[axis];

    this.positions.mouse.speed = Math.min(this.options.maxDrag, Math.max(1, (Math.abs(this.positions.mouse.distance) * this.options.dragIntensity)));

    if (Math.abs(this.positions.mouse[axis] - this.positions.click[axis]) > this.options.pixelsCheck && !__lastMove) {
      this.isDragged = true;
    }

    this.options.onMove(this.positions.mouse.distance * this.positions.mouse.speed);
  }

  _move() {
    this.container.addEventListener(Basics.moveEvent, (e) => {
      this.positions.mouse = {
        x: isTouch ? e.touches[0].screenX : e.clientX,
        y: isTouch ? e.touches[0].screenY : e.clientY,
      };

      if (this.isDragging) {
        this._doDragMove()
      } else {
        switch (e.target.tagName.toLowerCase()) {
          case "a":
            //NOT ANCHOR
            if (this.options.ajax &&
              e.target.getAttribute("href").slice(0, 1) !== "#" &&
              e.target.getAttribute("target") !== '_blank' &&
              e.target.getAttribute("data-internal") == null) {

              e.preventDefault();
              ControllerPage.preloadPage(e.target.getAttribute("href"));
            }

            break;
        }
      }

      this.positions.old = this.positions.mouse;
    });
  }

  _down() {
    this.container.addEventListener(Basics.downEvent, (e) => {
      this.positions.click = {
        x: isTouch ? e.touches[0].screenX : e.clientX,
        y: isTouch ? e.touches[0].screenY : e.clientY,
      };

      if (this.options.drag) {
        this._idTimer = setTimeout(() => {
          this.positions.mouse = this.positions.old = this.positions.click;
          this.isDragging = true;
          if (this.options.onDragStart) this.options.onDragStart();
        }, this.options.dragCheckTime);
      }

      if (this.options.onMouseDown) {
        this.options.onMouseDown();
      }
    });
  }

  _up() {
    this.container.addEventListener(Basics.upEvent, (e) => {
      clearInterval(this._idTimer);

      this.positions.up = {
        x: isTouch ? e.changedTouches[0].screenX : e.clientX,
        y: isTouch ? e.changedTouches[0].screenY : e.clientY,
      };

      if (this.isDragging) {
        this.isDragging = false;
        if (this.options.onDragEnd) this.options.onDragEnd();
        setTimeout(() => { this.isDragged = false; }, 100);
      }

      if (this.options.onMouseUp) {
        this.options.onMouseUp();
      }
    });
  }

  _click() {
    this.container.addEventListener(Basics.clickEvent, (e) => {
      if (this.isDragged) {
        e.preventDefault();
      } else {

      }
    });
  }
}

export { Interaction, MrInteraction }
